module.exports = __webpack_public_path__ + "img/apple4.60ec72e2.png";